import { FormSwitch } from '@ipfabric/ui-components/FormSwitch/FormSwitch';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';

export const resolveNames: FormSnippet<
  DiscoverySettingsObject,
  { resolveNames: boolean }
> = {
  render: ({ form }) => (
    <FormSwitch
      control={form.control}
      name='resolveNames'
      description='Discovered inventory - Resolve DNS name'
    />
  ), // Placeholder for the actual component
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.resolveNames =
      model.resolveNames.discoveryDevices ?? false;
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.resolveNames.discoveryDevices = transformedValues.resolveNames;
  },
  schema: z.object({
    resolveNames: z.boolean(),
  }),
};
